var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"view-domain-checker ws-typography"},[_c('domain-checker',{attrs:{"search":_vm.domainSearchFromQuery},on:{"check-started":_vm.onCheckStarted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }